import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  IconButton,
  SvgIcon,
  makeStyles
} from '@material-ui/core';
import { Menu as MenuIcon } from 'react-feather';
import { useLocation } from 'react-router-dom';
import NavBar from './NavBar';
import { useSelector } from 'react-redux';
import SiteFooter from 'src/components/SiteFooter';
import useSettings from 'src/hooks/useSettings';
import { THEME_MODES } from 'src/utils/resolveTheme';
import { INVENTORY_UI_FLAGS } from 'src/views/listView/inventoryUiFlags';
import { INVENTORY_LIGHT } from 'src/views/listView/inventoryTheme';
// import TopBar from './TopBar';

/** Fixed inventory mobile chrome (logo + logout / menu). Keep in sync with listView Header. */
export const INVENTORY_MOBILE_HEADER_HEIGHT_PX = 80;

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  },
  /** Light inventory preference: match inventory page bg on mobile chrome. */
  rootInventoryLightMobile: {
    [theme.breakpoints.down('md')]: {
      backgroundColor: INVENTORY_LIGHT.pageBg,
    },
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    // paddingTop: 64,
    // [theme.breakpoints.up('lg')]: {
    //   paddingRight: 200
    // }
  },
  /**
   * Inventory mobile: reserve space under the fixed logo / logout / menu so
   * `.content` scroll starts just above the search box (HomeLayout TopBar pattern).
   */
  wrapperInventoryMobileHeader: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: INVENTORY_MOBILE_HEADER_HEIGHT_PX,
    },
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: '1 1 auto'
  },
  MenuIconButton: {
    position: "fixed",
    color: "white",
    top: "15px",
    right: '25px',
    [theme.breakpoints.down("sm")]: {
      /** Match news mobile header right control (`top: 30`, `right: 24`). */
      top: 30,
      right: 17,
    },
    padding: 0,
    backgroundColor: "#191f29",
    border: 'solid 1px #0c111a',

    width: '50px',
    height: '50px',
    borderRadius: '50%',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: theme.zIndex.drawer - 50,
  },
  /** Light inventory: white circle chrome (matches listView logout / ThemeModeToggle). */
  MenuIconButtonLight: {
    backgroundColor: '#ffffff',
    border: 'solid 1px rgba(15, 23, 42, 0.12)',
    color: '#0F172A',
    boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
    '&:hover': {
      backgroundColor: '#F8FAFC',
    },
  },
  share: {
    color: "white",
    fontSize: "20px",
    width: "26px",
    height: "26px"
  },
  shareLight: {
    color: '#0F172A',
  },
}));

function DashboardLayout({ children }) {
  const classes = useStyles();
  const location = useLocation();
  const { settings } = useSettings();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const user = useSelector((state) => state.account.user);
  const isInventoryPage = Boolean(user) && location.pathname === '/app/solar-panels';
  const inventoryLightPreferred = !INVENTORY_UI_FLAGS.enableDarkTheme
    || settings.themeMode === THEME_MODES.LIGHT;

  return (
    <div
      className={clsx(
        classes.root,
        isInventoryPage && inventoryLightPreferred && classes.rootInventoryLightMobile
      )}
    >
      {user &&
        <IconButton
          className={clsx(
            classes.MenuIconButton,
            isInventoryPage && inventoryLightPreferred && classes.MenuIconButtonLight,
          )}
          onClick={() => setMobileNavOpen(true)}
        >
          {/* <Box style={{ display: "flex", flexDirection: "column", alignItems: "center" }}> */}
          <SvgIcon
            className={clsx(
              classes.share,
              isInventoryPage && inventoryLightPreferred && classes.shareLight,
            )}
          >
            <MenuIcon />
          </SvgIcon>
          {/* </Box> */}
        </IconButton>
      }
      {user &&
        <NavBar
          onMobileClose={() => setMobileNavOpen(false)}
          openMobile={isMobileNavOpen}
        />
      }
      <div
        className={clsx(
          classes.wrapper,
          isInventoryPage && classes.wrapperInventoryMobileHeader
        )}
      >
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            <div className={classes.main}>
              {children}
            </div>
            <SiteFooter />
          </div>
        </div>
      </div>
    </div>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.any
};

export default DashboardLayout;
